import { getRoute } from "../utils/helper";

export const EC_MEMBER_TYPE = [
  "Member Secretary",
  "Chairperson",
  "Social Scientist",
  "Lay Person",
  "Basic Scientist",
  "Clinician",
  "Legal Expert",
  "Women Member",
  "Others",
];

export const ALL_STUDY_PHASE = ["1", "2", "3", "4", "Others"];
export const ALL_TYPE_OF_STUDY = [
  "Sponsor",
  "DNB",
  "Academic",
  "IIS",
  "Others",
];
export const TYPES_OF_FUNDING = [
  "Sponsor Funded Project",
  "Investigator Funded Project",
  "Institution Funded Project",
  "Others",
];
export const ALL_TYPES_OF_PVPD = [
  "Blood sample collection NOT DONE",
  "Follow Up visits - MISSED",
  "Scheduled Visits - MISSED",
  "Investigations - NOT DONE",
  "Investigational Product related",
  "Inclusion/ Exclusion Criteria related",
  "Others",
];
export const APP_SETTINGS = {};

export const ACCESS_TOKEN = "accessToken";

export const ROLES = {
  ECS: "ECS",
  QA: "QA",
  INVESTIGATOR: "INVESTIGATOR",
  MIRB: "MIRB",
  MIEC: "MIEC",
  MSMC: "MSMC",
};

export const MEETING_TYPE = {
  MIRB: ROLES.MIRB,
  MIEC: ROLES.MIEC,
  MSMC: ROLES.MSMC,
};

export const IRB_SUBMISSION_TYPES = {
  ADDITIONAL_SUBMISSION: "ADDITIONAL_SUBMISSION",
  INITIAL_SUBMISSION: "INITIAL_SUBMISSION",
};

export const EC_SUBMISSION_TYPES = {
  INITAL_REVIEW: "INITIAL_REVIEW",
  ADDITIONAL_DOCUMENTS: "ADDITIONAL_DOCUMENTS",
  EC_NOTIFICATION: "EC_NOTIFICATION",
  EC_ANNUAL_REPORT: "EC_ANNUAL_REPORT",
  PVPD_DETAILS: "PVPD_DETAILS",
  SAE: "SAE",
  STUDY_CLOSEOUT_REPORT: "STUDY_CLOSEOUT_REPORT",
};
export const SUBMISSION_TYPES = {
  IRB: "IRB",
  EC: "EC",
  MEETING: "MEETING",
};

export const RoutingList = {
  index: getRoute("/", Object.values(ROLES)),
  demo: {
    index: getRoute("/demo", Object.values(ROLES)),
  },
  members: {
    index: getRoute("/members", [ROLES.ECS]),
    create: getRoute("/members/create", [ROLES.ECS]),
    details: getRoute("/members/:id", [ROLES.ECS]),
    edit: getRoute("/members/edit/:id", [ROLES.ECS]),
  },
  login: {
    index: getRoute("/login", Object.values(ROLES)),
    forgot_password: getRoute("/forgot-password", Object.values(ROLES)),
  },
  irb: {
    index: getRoute("/irb", [ROLES.ECS, ROLES.INVESTIGATOR, ROLES.MIRB]),
    create: getRoute("/irb/create", [ROLES.INVESTIGATOR]),
    createNotification: getRoute("/irb/create-notification", [
      ROLES.INVESTIGATOR,
    ]),
    details: getRoute("/irb/:id", [ROLES.ECS, ROLES.INVESTIGATOR, ROLES.MIRB]),
    edit: getRoute("/irb/edit/:id", [ROLES.INVESTIGATOR]),
  },
  irbAdditional: {
    index: getRoute("/irb-additional", [
      ROLES.ECS,
      ROLES.INVESTIGATOR,
      ROLES.MIRB,
    ]),
    create: getRoute("/irb-additional/create", [ROLES.INVESTIGATOR]),
    details: getRoute("/irb-additional/:id", [
      ROLES.ECS,
      ROLES.INVESTIGATOR,
      ROLES.MIRB,
    ]),
    edit: getRoute("/irb-additional/edit/:id", [ROLES.INVESTIGATOR]),
  },
  ethics_committee: {
    index: getRoute("/ec-submission", [
      ROLES.ECS,
      ROLES.QA,
      ROLES.INVESTIGATOR,
      ROLES.MSMC,
      ROLES.MIEC,
    ]),
    edit: getRoute("/ec-submission/edit/:id", [ROLES.INVESTIGATOR]),
    create: getRoute("/ec-submission/create", [ROLES.INVESTIGATOR]),
    details: getRoute("/ec-submission/:id", [
      ROLES.ECS,
      ROLES.QA,
      ROLES.INVESTIGATOR,
      ROLES.MSMC,
      ROLES.MIEC,
    ]),
  },
  profile: {
    index: getRoute("/profile", Object.values(ROLES)),
    edit: getRoute("/profile/edit", Object.values(ROLES)),
    password: getRoute("/profile/password", Object.values(ROLES)),
  },
  meeting: {
    index: getRoute("/meeting", [
      ROLES.ECS,
      ROLES.MIEC,
      ROLES.MIRB,
      ROLES.MSMC,
    ]),
    create: getRoute("/meeting/create", [ROLES.ECS]),
    edit: getRoute("/meeting/edit/:id", [ROLES.ECS]),
    details: getRoute("/meeting/:id", [
      ROLES.ECS,
      ROLES.MIEC,
      ROLES.MIRB,
      ROLES.MSMC,
    ]),
  },
  pageNotFound: getRoute("/*", Object.values(ROLES)),
};

export const stepsInfo = ["1. Study Details", "2. EC Submission"];
